import { Notifications as _Notification } from '@models/API/notify/notification.model';

export namespace Notify {
  export import Notification = _Notification;
}
